// Navigation des Moduls `kalibrierung` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul kalibrierung.
import { Scales } from '@phosphor-icons/react';
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'kalibrierung',
  title: 'Calibration & approval',
  nav: {
    admin: [
      {
        key: 'kalibrierung.board',
        label: 'Calibration',
        icon: Scales,
        path: '/performance/calibration',
        roles: ['ADM', 'PERF', 'CL', 'CEO'],
        order: 220,
        area: 'Performance',
      },
    ],
  },
});
